import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({ name: 'customCalendarCellImage' })
export class CustomCalendarCellImagePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  /**
   * Pipe filters the list of rooms-chat based on the search text provided
   *
   * @returns list of rooms filtered by search text or []
   * @param event
   * @param height
   * @param includeOtherMonthLabel
   * @param boxWeekDay
   */
  transform(
    event: any,
    height: string,
    includeOtherMonthLabel: any,
    boxWeekDay: string,
    headLess: boolean
  ): SafeHtml {
    let marginTop = '0';
    if (includeOtherMonthLabel && headLess) {
      const total = boxWeekDay + 10;
      marginTop = `-${total}px`;
    }

    const refTags = event.html.match(/src\s*=\s*"(.+?)"/gm);
    const imgTag = get(refTags, '0', null);
    if (imgTag) {
      const html = `<img ${imgTag} style="width: 100%; height: ${height}; object-fit: contain; margin-top: ${marginTop}" alt="tsolife"/>`;
      return this._sanitizer.bypassSecurityTrustHtml(html);
    }
    return '';
  }
}
